import React, { useEffect, useState, useRef } from "react";
import FieldRenderer from "./FieldRenderer";
import { Typography, Divider } from "antd";
import { AiFillTags } from "react-icons/ai";
import { Switch } from "antd";
import { gaEvent } from "analytics/analytics";
import * as GA from "../../../constants/analytics";

const { Title } = Typography;
const ICON_STYLE = {
  fontSize: 24,
  padding: 1,
  background: "#f5f5f5",
  borderRadius: 4,
  color: " #9B9F9E",
  marginRight: 10,
};
const ICON_CONTAINER = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "start",
};

export default function ExclusiveDetails({
  fields,
  setExclusiveDetailsButton,
  showExclusiveDetails,
  allCategoryData,
  categoryId
}) {
  const onChangeExclusiveToggle = () => {
    setExclusiveDetailsButton(!showExclusiveDetails);
  };

  const renderExclusiveToggle = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginTop: 20,
          marginBottom: 20,
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            marginBottom: 8,
          }}
        >
          <div
            style={{
              fontSize: 14,
              color: "#000000",
              fontWeight: "bold",
            }}
          >
            Is this product exclusively made for a buyer?
          </div>
          <div>
            <Switch
              onChange={onChangeExclusiveToggle}
              checked={showExclusiveDetails}
              onClick={() => {
                gaEvent(
                  GA.EVENT.CLICK,
                  GA.CATEGORY.ADD_PRODUCT,
                  GA.DESCRIPTION.INTERNAL_DETAILS_TOGGLE
                );
              }}
            />
          </div>
        </div>

        <div>
          <div style={{ fontSize: 14, color: "#797F7D" }}>
            Click on the toggle to enter buyer details
          </div>
        </div>
      </div>
    );
  };

  return (
    <div id="exclusive">
      {/* <div
				className="ant-divider ant-divider-horizontal"
				role="separator"
			></div> */}
      {fields?.[0] ? renderExclusiveToggle() : null}
      {showExclusiveDetails && (
        <FieldRenderer
          fields={fields}
          showExclusiveDetails={showExclusiveDetails}
          categoryId={categoryId}
          allCategoryData={allCategoryData}
        />
      )}
      {fields?.[0] ? <Divider /> : null}
    </div>
  );
}
